// extracted by mini-css-extract-plugin
export default {"cls1":"PremiumBadge-cls1_Lcz","cls2":"PremiumBadge-cls2__7x PremiumBadge-cls1_Lcz"};